<template>
  <div>
    <div class="ac-header">
      <div class="company">
        <img
          class="logo"
          :src="companyLogo"
          alt="logo"
        >
        <span
          class="ac-title"
        >{{ company }}</span>
      </div>
      <AuTooltip
        v-if="platformDescription.length > 0"
        type="slot"
        :description="platformDescription"
      >
        <div>
          {{ platformName }}
        </div>
      </AuTooltip>
      <div v-if="platformName.length > 0 && platformDescription.length === 0">
        {{ platformName }}
      </div>
    </div>
    <div
      v-if="isAutenticProject"
      class="ac-content"
    >
      <div class="content">
        <span class="ac-title">Autentic DAO: Mersin LLC</span>
        <span class="ac-text">Governing body</span>
      </div>
    </div>
    <div
      v-else
      class="ac-content"
    >
      <AuAvatar
        :f-name="user.fName"
        :i-name="user.iName"
      />
      <div class="content">
        <span class="ac-title">{{ name }}</span>
        <span class="ac-text">{{ role }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AuthorCapital",
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    company: {
      type: String,
      default: ""
    },
    companyLogo: {
      type: String,
      default: ""
    },
    platformName: {
      type: String,
      default: ""
    },
    platformDescription: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters({
      language: "language"
    }),

    name() {
      let fName = this.user.fName ?? "  ";
      fName = fName[0].toUpperCase() + fName.slice(1);
      let iName = this.user?.iName ?? " ";
      iName = iName[0].toUpperCase() + iName.slice(1);
      return `${fName} ${iName}`;
    },

    isAutenticProject() {
      return process.env.VUE_APP_VENDOR == "autentic";
    },

    role() {
      return this.language === "en" ? "Manager" : "Менеджер";
    }
  }
};
</script>

<style scoped lang="scss">
.ac-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid lightgrey;

  .company {
    display: flex;
    align-items: center;
    gap: 10px;

    .logo {
      width: 26px;
      height: 26px;
      object-fit: contain;
      border-radius: 50%;
    }
  }
}
.ac-title {
    font-size: 16px;
    font-weight: 500;
}
.ac-text {
  color: var(--color-50);
}
.ac-content {
  display: flex;
  gap: 15px;

  .avatar {
    width: 76px;
    height: 76px;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>